import { render, staticRenderFns } from "./FundManagerDetail.vue?vue&type=template&id=3fb8c157&"
import script from "./FundManagerDetail.vue?vue&type=script&lang=js&"
export * from "./FundManagerDetail.vue?vue&type=script&lang=js&"
import style0 from "./FundManagerDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports